export function NewMeal() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        marginTop: "8px",
      }}
    >
      <div style={{ width: "500px" }}>
        <iframe
          title="add-new-meal"
          className="airtable-embed"
          src="https://airtable.com/embed/appRyDpw6P4HZIdqT/pagOhsDEuqlxenlKd/form"
          width="100%"
          height="800"
          style={{ background: "transparent" }}
        ></iframe>
      </div>
    </div>
  );
}
